import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import { T } from '../../../traks';


export const CompanyInfo = ({ updateField, values, errors, isLoading }) => {
    return (
    <React.Fragment>
        <Row className='mb-2'>
            <Col>
            <label><T>EAN *</T></label>
            <Input
                type="text"
                value={values.ean}
                onChange={(e) => updateField('ean', e.target.value)}
                disabled={isLoading}
            />
            {errors.ean && <span className="text-danger form-error">{errors.ean}</span>}
            </Col>
        </Row>
    </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Checkout/CompanyInfo.js